import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import moment from 'jalali-moment';
import { toast } from 'react-toastify';

import { _post } from '../../../utils/network';

import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb.component';
import ListTable from '../../../components/List/ListTable/ListTable.component';
import Pagination from '../../../components/List/Pagination/Pagination.component';

const ContestForecastsList = () => {
	const { t } = useTranslation();
	const breadcrumbItems = [
		{ title: t('dashboard'), link: '/dashboard' },
		{ title: t('contest_forecasts'), link: '/contest-forecasts-list' },
		{ title: t('list') }
	];

	const [contestForecasts, setContestForecasts] = useState([]);
	let latestContestForecastsListData = {
		head: [t('creation_date'), t('contest'), t('user'), t('basket'), t('efficiency')],
		body: contestForecasts.map(contestForecast => [
			moment(contestForecast.create_date.substring(0, 10), 'YYYY-MM-DD').locale('fa').format('jYYYY/jMM/jDD'),
			contestForecast.contest_id_information.contest_name,
			<Link className='' to={`/users-edit/${contestForecast.user_id_information.user_id}`} target="_blank">
				{contestForecast.user_id_information.user_fullname}
			</Link>,
			<>
				{contestForecast.contestenroll_information.map(item => <div>{item.stock_symbol} - {item.stock_percent}%</div>)}
			</>,
			contestForecast.total_profit || 0
		]),
		directions: ['ltr', 'rtl', 'rtl', 'rtl', 'ltr']
	};
	
	const [pageNumber, setPageNumber] = useState(1);
	const [pageCounter] = useState(10);
	const [totalCount, setTotalCount] = useState(0);
	const [pagesCount, setPagesCount] = useState(0);
	const [searchCounter, setSearchCounter] = useState(0);
	const getContests = async () => {
		let body = {
			user_id: null,
			contest_id: null,
			sort: 'date',
			page: pageNumber,
			count: pageCounter
		};
		let response = await _post('/contestenrolls/admin/getAll', body);
		switch(response.code){
			case 200:
				setTotalCount(response.data.all_contestenrolls);
				setContestForecasts(response.data.contestenrolls);
				break;
			default:
				toast.error(response[t('api_message')]);
		}
	};

	useEffect(() => {
		setPagesCount(Math.ceil(totalCount / pageCounter));
	}, [totalCount]);
	
	useEffect(() => {
		setSearchCounter(searchCounter + 1);
	}, [pageNumber]);

	useEffect(() => {
		getContests();
	}, [searchCounter]);
	
	return (
		<>
			<Breadcrumb items={breadcrumbItems} />
			<ListTable title={t('forecasts')} pageNumber={pageNumber} pageCounter={pageCounter} totalCount={totalCount} data={latestContestForecastsListData} />
			<Pagination pagesCount={pagesCount} action={setPageNumber} />
		</>
	);
};

export default ContestForecastsList;
